import { OnboardingPackageItem } from 'features/Onboarding/modules/PricingPlan/machine/model';
import { ActiveProviderPlanId } from 'types/planUtils';

import locales from '../locales';
import { OnboardingPlanDisplay, PaymentCardLimits } from '../types';

interface GetOnboardingPlanDisplayArgs {
  capDepAmount: number;
  item: OnboardingPackageItem;
  paymentCardLimits: PaymentCardLimits;
}

const getOnboardingPlanDisplay = ({
  capDepAmount,
  item,
  paymentCardLimits,
}: GetOnboardingPlanDisplayArgs): OnboardingPlanDisplay => ({
  brandColor: item.plan.brandColor,
  brandName: item.plan.brandName,
  customerSupport: item.plan.customerSupport,
  discountPrice: item.discountPriceWithoutVAT - capDepAmount,
  features: item.plan.features,
  label: `${item.trialPeriod} ${locales.months}  ${item.plan.brandName}`,
  limits: item.plan.limits,
  packageType: item.type,
  paymentCard: item.plan.paymentCard,
  paymentCeiling:
    paymentCardLimits[item.plan.paymentCard.type as keyof PaymentCardLimits]
      .maxLimitPaymentWeek * 4,
  planPrice: item.plan.priceWithoutVAT,
  price: item.plan.priceWithoutVAT * 12,
  providerPackageId: item.providerPackageId,
  // force to ActiveProviderPlanId to ignore archived plans
  providerPlanId: item.plan.providerPlanId as ActiveProviderPlanId,
  trialPeriod: 12,
  withdrawalCeiling:
    paymentCardLimits[item.plan.paymentCard.type as keyof PaymentCardLimits]
      .maxLimitAtmMonth,
});

export default getOnboardingPlanDisplay;
